const LOGO_URL =
    "https://customer-assets.emergentagent.com/job_silvia-fotografia/artifacts/k8ptqvsd_D2D81E8C-1AA1-49C2-A355-DCF14264CCB0.png";

export default function Logo({ light = false, size = "md" }) {
    // Size presets — all variants use the official PNG with transparent background.
    const sizes = {
        sm: "h-12 sm:h-14 w-auto", // Navbar (top-left)
        md: "h-16 sm:h-20 w-auto", // Footer
        lg: "w-full max-w-[640px] sm:max-w-[760px] lg:max-w-[860px] h-auto", // Hero (cover)
    };

    const className = sizes[size] || sizes.md;

    return (
        <div
            className="relative inline-flex items-center justify-center"
            data-testid="brand-logo"
        >
            <img
                src={LOGO_URL}
                alt="Silvia García · Fotógrafa"
                className={`${className} object-contain select-none`}
                style={{
                    filter: light ? "invert(1)" : "none",
                }}
                draggable={false}
            />
        </div>
    );
}
